// MODULES
import React from "react";
import PropTypes from "prop-types";

// HELPERS
import { createClassName } from "@helpers/utils";

// ASSETS
import sprite from "@assets/vendor/feathericons/feather-sprite.svg";


export default class FeatherIcon extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
        fillColor: PropTypes.string.isRequired,
        strokeColor: PropTypes.string.isRequired,
        strokeWidth: PropTypes.number.isRequired,
        strokeLinecap: PropTypes.string.isRequired,
        strokeLinejoin: PropTypes.string.isRequired,
        appearance: PropTypes.string,
        onClick: PropTypes.func,
    }
    static defaultProps = {
        size: 24,
        fillColor: "none",
        strokeColor: "currentColor",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
    }

    render() {
        const { props } = this;
        const { type, size, fillColor, strokeColor, strokeWidth, strokeLinecap, strokeLinejoin, appearance, onClick } = props;
        const classes = createClassName(props.className, {
            "FeatherIcon": true,
            [type]: true,
            [appearance]: !!appearance,
        });

        return (
            <svg
                className={ classes }
                width={ size }
                height={ size }
                fill={ fillColor }
                stroke={ strokeColor }
                strokeWidth={ strokeWidth }
                strokeLinecap={ strokeLinecap }
                strokeLinejoin={ strokeLinejoin }
                onClick={ onClick }
            >
                <use xlinkHref={ sprite + "#" + type } />
            </svg>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/FeatherIcon/FeatherIcon.js